import { render, staticRenderFns } from "./refNFForm.vue?vue&type=template&id=bb4724c8&"
import script from "./refNFForm.vue?vue&type=script&lang=js&"
export * from "./refNFForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports